<script>
import TabsStatisticAttestation from "./TabsStatisticAttestation.vue";
import CardStatisticAttestation from "./CardStatisticAttestation.vue";

const CardGraphUniversityStatisticAttestation = async () => import("./CardGraphUniversityStatisticAttestation.vue");
const CardGraphFacultyStatisticAttestation = async () => import("./CardGraphFacultyStatisticAttestation.vue")
const TheFacultyStatisticsCard = async  () => import("./TheFacultyStatisticsCard.vue");

export default {
  name: "ThePageStatisticAttestationFacultyAndUniversity",

  components: {
    CardStatisticAttestation,
    TabsStatisticAttestation,
    TheFacultyStatisticsCard,
    CardGraphFacultyStatisticAttestation,
    CardGraphUniversityStatisticAttestation,
  },

  data() {
    return {
      departments: [1165,3,4,5,6,7,8,9,1041],
      tab: 0,
    };
  },
}
</script>

<template>
  <v-app>
    <v-main>

      <v-tabs
        v-model="tab"
        align-with-title
        grow
        color="teal darken-3"
      >
        <v-tab
          key="tables"
        >
          Таблицы
        </v-tab>
        <v-tab
          key="graphs"
        >
          Графики
        </v-tab>
        <v-tab
          key="graphs-university"
        >
          График по вузу
        </v-tab>
      </v-tabs>


      <v-divider class="mb-5"/>

      <v-tabs-items v-model="tab">
        <v-tab-item
          key="tables"
        >
          <the-faculty-statistics-card
            v-for="department in departments"
            :key="department"
            :department="department"
            class="mb-5"
          />
        </v-tab-item>

        <v-tab-item
          key="graphs"
        >
          <card-graph-faculty-statistic-attestation
            v-for="department in departments"
            :key="department"
            :department="department"
          />
        </v-tab-item>

        <v-tab-item
          key="graphs-university"
        >
          <card-graph-university-statistic-attestation/>
        </v-tab-item>

      </v-tabs-items>


    </v-main>
  </v-app>
</template>

<style scoped>

</style>